/**
 * UTM Parameter Tracking Utility
 * Captures and persists UTM parameters for marketing attribution
 */

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const UTM_STORAGE_KEY = 'courtiq_utm';
const UTM_EXPIRY_DAYS = 30;

/**
 * Capture UTM parameters from current URL and store them
 */
export const captureUTMParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmData = {};
  let hasUTM = false;

  UTM_PARAMS.forEach(param => {
    const value = urlParams.get(param);
    if (value) {
      utmData[param] = value;
      hasUTM = true;
    }
  });

  if (hasUTM) {
    // Add capture metadata
    utmData.captured_at = new Date().toISOString();
    utmData.landing_page = window.location.pathname;
    utmData.referrer = document.referrer || null;
    
    // Store in localStorage with expiry
    const storageData = {
      data: utmData,
      expiry: Date.now() + (UTM_EXPIRY_DAYS * 24 * 60 * 60 * 1000)
    };
    localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(storageData));
    
    console.log('[UTM] Captured:', utmData);
  }

  return utmData;
};

/**
 * Get stored UTM parameters (if not expired)
 */
export const getStoredUTMParams = () => {
  try {
    const stored = localStorage.getItem(UTM_STORAGE_KEY);
    if (!stored) return null;

    const { data, expiry } = JSON.parse(stored);
    
    // Check if expired
    if (Date.now() > expiry) {
      localStorage.removeItem(UTM_STORAGE_KEY);
      return null;
    }

    return data;
  } catch (e) {
    console.warn('[UTM] Error reading stored params:', e);
    return null;
  }
};

/**
 * Clear stored UTM parameters (call after successful conversion)
 */
export const clearUTMParams = () => {
  localStorage.removeItem(UTM_STORAGE_KEY);
};

/**
 * Get UTM params for API submission (flattened format)
 */
export const getUTMForAPI = () => {
  const utm = getStoredUTMParams();
  if (!utm) return {};
  
  return {
    utm_source: utm.utm_source || null,
    utm_medium: utm.utm_medium || null,
    utm_campaign: utm.utm_campaign || null,
    utm_content: utm.utm_content || null,
    utm_term: utm.utm_term || null,
    utm_landing_page: utm.landing_page || null,
    utm_referrer: utm.referrer || null
  };
};

export default {
  captureUTMParams,
  getStoredUTMParams,
  clearUTMParams,
  getUTMForAPI
};
